import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col, Button,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {RiSettings3Line} from "react-icons/ri";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class HowToSetUpAndManagePreferredSongBooksHelp extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    // sessionStorage.removeItem("customer");
  }

  stepsData = [
    {
      title: "Coming soon",
      description: "Please bear with us as we build our help tutorial articles" +
          "<img src=\"/help-images/thank-you.jpg\" style=\"width: 410px; height: auto;\">"
      // },
      // {
      //   title: "What's next",
      //   description: "You can now access all member features:" +
      //       "<br/><br/>! Content goes here !" +
      //       "<br/><br/>" +
      //       "<br/></br><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/your-profile/saved-song-flows'>!Some feature !</a>",
      //   image: "/help-images/well-done.png",
      //   enlargeable: false
    },
  ];


  render() {
    return (
      <>
        <SeoHelper
            uri="/help/how-to-set-up-and-manage-preferred-song-books"
            title = "Learn how to set up and manage preferred song books | Help | The Worship Bible"
            description={"Learn how to set up and manage preferred song books"} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>help</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          <Row className="mt-3">
                            <Col>
                              <div className="d-flex align-items-center mb-3">
                                <RiSettings3Line color="#5e72e4" size="24" className="mr-2"/>
                                <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">How to set up and manage preferred song books</h2>
                              </div>
                            </Col>
                            <Col md="3" xs="12">
                              <Button
                                  block
                                  type="submit"
                                  className="mb-2"
                                  color="white"
                                  href="/help"
                              >
                                <span className="btn-inner--text">Back to help</span>
                              </Button>
                            </Col>
                          </Row>
                          <p className="description mt-3">
                            <InstructionsWizard stepsData={this.stepsData} />
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default HowToSetUpAndManagePreferredSongBooksHelp;
